import React, { useContext } from 'react';

import { Button, Grid, TextField, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { Context } from 'context';
import { getCurrentYear } from 'utils';
import { PAGE_URLS } from 'Routes/Main/constants';
import styles from './LoginRightPanel.module.scss';
import clsx from 'clsx';

const OtpVerification = ({ handleChange, handleLogin }) => {
  const {
    state: {
      domainConfig: { logo, logoAlt, showPoweredBy },
    },
  } = useContext(Context);

  return (
    <div className={styles.rightContainer}>
      <div className={styles.innerContainer}>
        <img className={styles.logoImage} src={logo} alt={logoAlt} />
        <Typography className={styles.headingH2} variant="h2">
          OTP Verification
        </Typography>

        <Typography className={styles.subHeading} variant="body1">
          Enter OTP sent to your email
        </Typography>

        <div className={styles.formContainer}>
          <TextField
            fullWidth
            id="otp-input"
            className={styles.formInputContainerWithSubBtn}
            label="Enter your 6 digit OTP"
            variant="outlined"
            onChange={handleChange('mobile')}
            inputProps={{
              'data-testid': 'otp-input',
            }}
          />

          <div
            className={clsx(
              styles.rememberContainer,
              styles.formInputContainer,
            )}
          >
            <div className={styles.rememberLinkContainer}>
              <Link
                className={styles.rememberLink}
                to={PAGE_URLS.LOGIN}
                data-testid="otp-login-link"
              >
                {' '}
                Login?{' '}
              </Link>
            </div>
          </div>

          <div className={styles.loginBtnContainer}>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              onClick={handleLogin}
              data-testid="otp-submit-button"
            >
              Submit
            </Button>
          </div>
        </div>

        {showPoweredBy && (
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            className="mg_top_100"
          >
            <Grid item>
              <img src={'/images/poweredByLogo.svg'} alt={logoAlt} />
            </Grid>

            <Grid item>
              <Typography
                variant="caption"
                className={styles.rememberLinkContainer}
              >
                &copy;{getCurrentYear()} &nbsp; &#9679; &nbsp; Subscribili
                &nbsp; &#9679; &nbsp; All Rights Reserved
              </Typography>
            </Grid>
          </Grid>
        )}
      </div>
    </div>
  );
};

export default OtpVerification;
